import * as EasyMDE from 'easymde'

export const easyMDEInit = (mdeEditor: HTMLTextAreaElement) => {
	const options = {
		element: mdeEditor,
		autofocus: true,
		forceSync: true,
		indentWithTabs: true,
		promptURLs: true,
		toolbar: ['bold', 'italic', 'strikethrough', '|',
			'heading', 'heading-smaller', 'heading-bigger', '|',
			'heading-1', 'heading-2', 'heading-3', '|',
			'code', 'quote', 'unordered-list', 'ordered-list', '|',
			'link', 'image', 'horizontal-rule', '|',
			'preview', 'side-by-side', 'fullscreen', 'clean-block', '|',
			'guide'
		]
	}
	const easymde = new EasyMDE(options)
	return easymde
}
